import moment from 'moment';
var RECURRENCE_ALLOWED_SLUG = 'space-reservation-recurrence-allowed';
export var SPACE_RESERVATION_MAX_LENGTH_SLUG = 'space-reservation-max-length';
/**
 * Users with `spaces:bypass_booking_policies` on a space are exempt from
 * that space's booking policies (recurrence restrictions, ABT, etc.).
 */
export function canBypassSpaceBookingPolicy(space) {
    var _a;
    return ((_a = space.permissions) === null || _a === void 0 ? void 0 : _a['spaces:bypass_booking_policies']) === true;
}
/**
 * Returns true when the user may create recurrence on this space — either
 * because the space allows it or the user can bypass policies on it.
 */
export function isRecurrenceAllowedForSpace(space) {
    var _a, _b;
    if (canBypassSpaceBookingPolicy(space)) {
        return true;
    }
    return (((_b = (_a = space.settings) === null || _a === void 0 ? void 0 : _a.find(function (s) { return s.slug === RECURRENCE_ALLOWED_SLUG; })) === null || _b === void 0 ? void 0 : _b.value) ===
        'true');
}
/**
 * Recurrence is allowed when every selected space permits it (or is bypassed).
 * When no spaces are selected, recurrence controls stay available.
 */
export function isRecurrenceAllowedForSpaces(spaces) {
    if (!(spaces === null || spaces === void 0 ? void 0 : spaces.length)) {
        return true;
    }
    return spaces.every(isRecurrenceAllowedForSpace);
}
function parseSpaceMaxLengthDuration(space) {
    var _a;
    var setting = (_a = space.settings) === null || _a === void 0 ? void 0 : _a.find(function (s) { return s.slug === SPACE_RESERVATION_MAX_LENGTH_SLUG; });
    if (!(setting === null || setting === void 0 ? void 0 : setting.value))
        return null;
    var duration = moment.duration(setting.value);
    var ms = duration.asMilliseconds();
    if (!ms || ms <= 0 || !Number.isFinite(ms))
        return null;
    return duration;
}
/**
 * Returns true when (ended_at - started_at) exceeds the given max length.
 */
export function eventDurationExceedsMaxLength(startTime, endTime, maxLength) {
    if (!startTime || !endTime || !startTime.isValid() || !endTime.isValid()) {
        return false;
    }
    var eventDurationMs = endTime.diff(startTime);
    return eventDurationMs > maxLength.asMilliseconds();
}
/**
 * Returns spaces whose max-reservation-length policy is violated by the
 * current event duration. Spaces without a max-length setting, and spaces
 * where the user has `spaces:bypass_booking_policies`, are excluded.
 */
export function getSpacesWithMaxLengthViolation(spaces, startTime, endTime) {
    if (!(spaces === null || spaces === void 0 ? void 0 : spaces.length) || !startTime || !endTime)
        return [];
    return spaces.filter(function (space) {
        if (canBypassSpaceBookingPolicy(space))
            return false;
        var maxLength = parseSpaceMaxLengthDuration(space);
        if (!maxLength)
            return false;
        return eventDurationExceedsMaxLength(startTime, endTime, maxLength);
    });
}
/**
 * Returns true when any selected space violates its max-reservation-length
 * policy for the current start/end times.
 */
export function hasMaxLengthViolation(spaces, startTime, endTime) {
    return getSpacesWithMaxLengthViolation(spaces, startTime, endTime).length > 0;
}
